module.exports = __webpack_public_path__ + "img/search-linear-24x24.84af6e9f.svg";